import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { Box } from '@chakra-ui/react'

import {
  BadgeCounter,
  FilterIcon,
  IconButton,
  TableToolbar,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { useAppSelector } from '@/redux/hooks'
import { incidentRulesFilterCountSelector } from '@/redux/ui/uiSlice'

import { RULES_TABLE_MAX_WIDTH } from '../constants/layout'
import { DarkRulesFilterDrawer } from '../rules-filter-drawer/dark'

interface DarkRulesSearchFilterHeaderIProps {
  colorScheme: ColorScheme
  filter: string
  setFilter: (value: string) => void
}

export const DarkRulesSearchFilterHeader = ({
  colorScheme,
  filter,
  setFilter,
}: DarkRulesSearchFilterHeaderIProps) => {
  const { t } = useTranslation()
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false)
  const filterCount = useAppSelector(incidentRulesFilterCountSelector)

  return (
    <>
      <TableToolbar
        actions={
          <Box
            alignItems='center'
            cursor='pointer'
            display='flex'
            gap='8px'
            onClick={() => setIsFilterDrawerOpen(true)}
          >
            {filterCount > 0 && (
              <BadgeCounter
                colorScheme={colorScheme}
                count={filterCount}
                variant='button'
              />
            )}
            <IconButton
              aria-label={t('common:filter')}
              colorScheme={colorScheme}
              dimension={36}
              icon={<FilterIcon colorScheme={colorScheme} />}
            />
          </Box>
        }
        colorScheme={colorScheme}
        maxWidth={RULES_TABLE_MAX_WIDTH}
        onChange={setFilter}
        placeholder={t('automations:search_rules_placeholder')}
        value={filter}
      />
      <DarkRulesFilterDrawer
        colorScheme={colorScheme}
        isOpen={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
      />
    </>
  )
}
